import React, { Component } from "react";
import { Button, Form, Modal } from "semantic-ui-react";

export default class AlertModal extends Component {
  render() {
    return (
      <Modal
        dimmer="blurring"
        size="tiny"
        open={this.props.isOpen}
        onClose={() => this.props.isClose()}
      >
        <Modal.Content
          style={{
            marginTop: "2%",
            fontSize: "16px",
            borderRadius: "0",
            textAlign: "center",
          }}
        >
          <div
            style={{
              marginTop: "5% ",
              fontWeight: "bold",
              fontSize: "18px",
            }}
          >
            {this.props.text}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginTop: "5% ",
              marginBottom: "5% ",
            }}
          >
            <Button
              //   basic
              style={{
                fontSize: "16px",
                fontFamily: "Kanit",
                fontWeight: "300",
              }}
              positive
              onClick={() => this.props.isClose()}
            >
              ตกลง
            </Button>
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}
